import {AfterViewInit, ContentChild, Directive, ElementRef, Input, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {fromEvent, startWith, Subject, takeUntil} from "rxjs";
import {map, pairwise} from "rxjs/operators";
import {PinnedElementDirective} from "./pinned-element.directive";
import {Home365Constants} from "@home365/common-classes";

@Directive({
  selector: '[libPinnedContainer]'
})
export class PinnedContainerDirective implements OnInit, AfterViewInit, OnDestroy {
  @Input() maxScreenSize: 'mobile' | 'tablet' | 'laptop' | 'all' = 'mobile';
  @Input() pinToTop = true;
  @ContentChild(PinnedElementDirective) hidden!: PinnedElementDirective;
  private _destroy$ = new Subject<null>();
  constructor(private elementRef: ElementRef, private renderer: Renderer2) {
  }
  ngOnInit() {
    this.renderer.addClass(this.elementRef.nativeElement, 'home365-scrollable-container');
    this.renderer.addClass(this.elementRef.nativeElement, this._getClass());
  }

  ngAfterViewInit() {
    this._init();
    fromEvent(window, 'resize').pipe(takeUntil(this._destroy$)).subscribe(() => this._init());
  }
  ngOnDestroy() {
    this._destroy$.complete();
  }

  private _init() {
    if(this.hidden) {
      this.hidden.containerElement = this.elementRef.nativeElement;
      this.hidden.pinToTop = this.pinToTop;
      if (!this.maxScreenSize || window.screen.width < this._getBreakpoint()) {
        this._initDom();
        fromEvent<Event>(this.elementRef.nativeElement, 'scroll').pipe(
          // @ts-ignore
          map(event => event.target?.scrollTop),
          pairwise(),
          startWith(this.pinToTop ? [1, 0] : [0, 1])
        ).subscribe(([prev, cur]) => {
         // console.log({prev, cur});
          this._calcPin(prev, cur);
        });
      } else {
        this.hidden.pinElement();
      }
    }
    
  }
  private _calcPin(prev: number, cur: number) {
    if ((this.pinToTop && cur < prev) || (!this.pinToTop && prev < cur)) {
      this.hidden.pinElement();
    } else {
      this.hidden.resetPin();
    }
  }
  private _initDom() {
    this.renderer.addClass(this.elementRef.nativeElement, 'pos-relative');
    this.hidden.init();
  }
  private _getBreakpoint() {
    switch (this.maxScreenSize) {
      case 'mobile':
        return Home365Constants.ScreenSize.mobile;
      case 'tablet':
        return Home365Constants.ScreenSize.tablet;
      case 'laptop':
        return Home365Constants.ScreenSize.lapTop;
      default:
        return Home365Constants.ScreenSize.lapTop;
    }
  }
  private _getClass() {
    switch (this.maxScreenSize) {
      case 'mobile':
        return 'scroll-in-mobile';
      case 'tablet':
        return 'scroll-in-tablet';
      case 'laptop':
        return 'scroll-in-laptop';
    }
    return '';
  }
}
